export default __webpack_public_path__ + "static/media/logo-light.a92d30b9.png";